import {
  Radio,
  FormControlLabel,
  RadioGroup,
  Typography,
  Box,
  TextField,
  Button,
  Divider,
  Dialog,
  DialogContent,
  Checkbox,
  Menu,
  MenuItem,
} from "@mui/material";
import { useSnackbar } from "notistack";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function AllRoutsLists(props) {
  const { isSmall } = useBreakpoints();
  const { enqueueSnackbar } = useSnackbar();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        overflowY: "auto",
        height: "100%",
      }}
      gridColumn={isSmall ? "span 12" : "span 2"}
    >
      <Typography
        variant="subtitle1"
        sx={{
          textAlign: "center",
          width: "100%",
          p: 1,
          borderBottom: "1px solid #cdcdcd",
        }}
      >
        روت ها
      </Typography>
      <Box
        sx={{
          height: "100%",
          overflowY: "auto",
          width: "100%",
          px: 0.5,
          my: 1,
        }}
      >
        <RadioGroup
          defaultValue={""}
          aria-labelledby="demo-controlled-radio-buttons-group"
          name="controlled-radio-buttons-group"
          value={props.locationRout.zoneIndex ?? " "}
          onChange={(event) => {
            props.setLocationRout({
              id: undefined,
              zoneIndex: event.target.value,
            });
          }}
        >
          {props.routes &&
            props.routes.map((m) => {
              return (
                <Box
                  key={m.id}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    py: 0.5,
                    borderBottom: "1px solid #cdcdcd",
                  }}
                >
                  <span
                    style={{
                      marginLeft: "10px",
                      backgroundColor: m.color,
                      width: "1rem",
                      height: "1rem",
                      borderRadius: "3rem 3rem 0",
                      display: "block",
                      position: "relative",
                      transform: "rotate(45deg)",
                    }}
                  ></span>
                  {/* <LocationIcon sx={{ width: "20px" }} fill={m.color} /> */}
                  <FormControlLabel
                    value={m.zoneIndex}
                    sx={{
                      "&.MuiFormControlLabel-root .MuiFormControlLabel-label ":
                        {
                          color: "secondary.main",
                        },
                    }}
                    control={<Radio size="small" color="secondary" />}
                    label={
                      <Typography variant="subtitle2">
                        {m.title} ({m.orders})
                      </Typography>
                    }
                  />
                </Box>
              );
            })}
        </RadioGroup>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          borderTop: "1px solid #cdcdcd",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
            borderBottom: "1px solid #cdcdcd",
          }}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={props.assigned}
                onChange={(event) => {
                  props.setAssigned(event.target.checked);
                  props.setLocationRout({
                    ...props.locationRout,
                    id: undefined,
                  });
                }}
              />
            }
            label="اختصاص به روت"
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            p: 1,
            py: 2,
            gap: 1,
          }}
        >
          <TextField
            sx={{
              width: "100%",
              input: {
                textAlign: "center",
              },
            }}
            value={props.orderModel.orderID ? props.orderModel.orderID : ""}
            label="سفارش"
            size="small"
            variant="outlined"
            onChange={(evt) => {
              props.setOrderModel({
                ...props.orderModel,
                orderID: evt.target.value,
                logesticID: undefined,
              });
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
          <Button
            variant="contained"
            onClick={() => {
              if (props.orderModel.orderID) {
                let model = {
                  deliveryDate: props.orderModel.deliveryDate,
                  deliveryPart: props.orderModel.deliveryPart,
                  orderID: Number(props.orderModel.orderID),
                };
                props.callBack(model);
              } else {
                enqueueSnackbar("لطفا سفارش را انتخاب کنید", {
                  variant: "error",
                  autoHideDuration: 2000,
                  preventDuplicate: true,
                });
                return;
              }
            }}
          >
            ویرایش
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
